import { render, staticRenderFns } from "./StammListe.vue?vue&type=template&id=47ea01b4&scoped=true"
import script from "./StammListe.vue?vue&type=script&lang=ts"
export * from "./StammListe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea01b4",
  null
  
)

export default component.exports